import { ReactNode } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { senecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";

interface SenecThemeProviderProps {
    children?: ReactNode;
}

/**
 * ThemeProvider for Material UI components to apply the SENEC EKP theme.
 * Wrap around all components at the root to apply to all children.
 *
 * @param props React.FunctionComponentProps
 * @returns Material UI ThemeProvider using the SENEC theme
 */
export const SenecEkpThemeProvider = ({ children }: SenecThemeProviderProps) => {
    return (
        <ThemeProvider theme={senecEkpTheme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};
